import { Dialog, IconButton, Stack } from "@mui/material";
import { CustomTextView } from "./CustomTextView";
import { COLOR_MAIN, COLOR_WHITE } from "../../data/colors/Colors";
import { CloseRounded } from "@mui/icons-material";
import { CustomButtonView } from "./CustomButtonView";
import { useTranslation } from "react-i18next";

interface AlertDialogControls {
  open: boolean;
  title: string;
  description: string;
  handleNegativeButtonClick: () => void;
  handlePositiveButtonClick: () => void;
}

export const CustomAlertDialog: React.FC<AlertDialogControls> = ({
  open,
  title,
  description,
  handleNegativeButtonClick,
  handlePositiveButtonClick,
}: AlertDialogControls) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={handleNegativeButtonClick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      slotProps={{ paper: { style: { borderRadius: 16, minWidth: "40vw" } } }}
    >
      <Stack gap={2}>
        <Stack
          direction={"row"}
          alignItems={"center"}
          p={2}
          bgcolor={COLOR_MAIN}
          width={"100%"}
          justifyContent={"space-between"}
        >
          <CustomTextView
            text={title}
            fontWeight="bold"
            variant="h6"
            textColor={COLOR_WHITE}
          />

          <IconButton
            onClick={handleNegativeButtonClick}
            sx={{ width: 40, height: 40, background: "rgba(135,40,77,1)" }}
          >
            <CloseRounded sx={{ color: "white" }} />
          </IconButton>
        </Stack>
        <Stack p={2} gap={4}>
          <CustomTextView text={description} variant="h6" />
          <Stack
            direction={"row"}
            alignItems={"center"}
            width={"100%"}
            justifyContent={"end"}
            gap={1}
          >
            <CustomButtonView
              text={t("cancel")}
              backgroundColor="gray"
              props={{ pl: 1, pr: 1 }}
              onClick={handleNegativeButtonClick}
            />
            <CustomButtonView
              text={t("confirm")}
              backgroundColor={COLOR_MAIN}
              props={{ pl: 1, pr: 1 }}
              onClick={handlePositiveButtonClick}
            />
          </Stack>
        </Stack>
      </Stack>
    </Dialog>
  );
};
